import get from "lodash/get";
import flow from "lodash/flow";
import toArray from "lodash/toArray";

const initialState = { opportunitiesList: [] };

export default function opportunityReducer(state = initialState, action) {
  switch (action.type) {
  case "CLEAR_ALL_INPUT":
    return initialState;
  case "SET_OPPORTUNITIES_LIST":
    return setOpportunitiesList(state, action);
  case "SET_ACCOUNT":
    return setOpportunitiesList(state, action);
  case "SET_ENTRY":
    return setOpportunitiesList(state, action);
  default:
    return state;
  }
}

function extractOpportunitiesList(action) {
  switch(get(action, "type")) {
  case "SET_OPPORTUNITIES_LIST":
    return get(action, "payload", []);
  case "SET_ACCOUNT":
    return get(action, "payload.opportunities", []);
  case "SET_ENTRY":
    return get(action, "payload.account.opportunities", []);
  default:
    return [];
  }
}

const getOpportunitiesList = flow(extractOpportunitiesList, toArray);

function setOpportunitiesList(state, action) {
  return { ...state, opportunitiesList: getOpportunitiesList(action) };
}



// WEBPACK FOOTER //
// ./app/reducers/timeInput/opportunities.js